<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class TourBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest

        get items() {
            const route = useRoute()
            const name = route.name
            const items = [this.homeItem]
            let basketItem
            switch (name) {
                case 'tourSearch':
                    items.push({
                        title: `${toursRuntimeStore.arrivalCity.name}, ${toursRuntimeStore.arrivalCity.countryName}`,
                        to: toursRuntimeStore.searchPageLink(this.searchRequest),
                        disabled: true,
                        exact: true,
                    })
                    break
                case 'tour':
                    items.push({
                        title: `${toursRuntimeStore.arrivalCity.name}, ${toursRuntimeStore.arrivalCity.countryName}`,
                        to: toursRuntimeStore.searchPageLink({
                            ...this.searchRequest,
                            ...(route.query.startDateTo && {startDateTo: route.query.startDateTo}),
                            packageTourId: null,
                        }),
                        exact: true,
                    })
                    items.push({
                        title: decodeURIComponent(toursRuntimeStore.packageTourInfo.name),
                        disabled: true,
                    })
                    break
                case 'tourBooking':
                    items.push({
                        title: `${toursRuntimeStore.arrivalCity.name}, ${toursRuntimeStore.arrivalCity.countryName}`,
                        to: toursRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                    basketItem = toursStore.basketItem(route.query.offerKey)
                    items.push({
                        title: decodeURIComponent(toursRuntimeStore.packageTourInfo.name),
                        to: {
                            name: 'tour',
                            query: {
                                ...basketItem.searchRequest,
                                packageTourId: basketItem.searchRequest.packageTourId,
                                duration: toursRuntimeStore.packageTourInfo.duration,
                            },
                        },
                        exact: true,
                    })
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'tourConfirmation':
                    items.push({
                        title: decodeURIComponent(toursRuntimeStore.packageTourInfo.name),
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(TourBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
